import PropTypes from "prop-types";
import { useState } from "react";

import API from "CrossFeatureComponents/UserRecurringGifts/API";
import { useRecurringGifts } from "CrossFeatureComponents/UserRecurringGifts/RecurringGiftsContext";
import PaymentTypeHandler from "Giving/ManageMyGivingPage/PaymentTypeHandler";

import FnrButton from "UI/FnrButton3";

import {
  PopoverBorder,
  PopoverButtonsContainer,
  PopoverContent,
  PopoverMessage,
  PopoverTitle,
} from "./styles";

PausedContent.propTypes = {
  paymentType: PropTypes.string,
  nextPaymentDate: PropTypes.string,
  ID: PropTypes.number,
  handleClose: PropTypes.func,
};

export default function PausedContent({
  paymentType,
  nextPaymentDate,
  ID,
  handleClose,
}) {
  const { dispatch } = useRecurringGifts();
  const [resuming, setResuming] = useState(false);

  const paymentTypeHandler = new PaymentTypeHandler(paymentType);

  const handleResume = () => {
    setResuming(true);

    let apiCall = API.unpause || null;

    if (!apiCall) return console.log("call not found.");

    apiCall({ ID })
      .post()
      .then((res) => {
        dispatch({
          type: "setRecurringGifts",
          payload: res.recurringGifts,
        });
        dispatch({
          type: "setThirtyDayTotal",
          payload: res.thirtyDayTotal,
        });
      })
      .catch((e) => {
        setResuming(false);
        alert(
          "Oh no! A problem occurred. Please try again or contact help@flocknote.com for assistance."
        );
        handleClose();
      });
  };

  return (
    <PopoverContent>
      <PopoverTitle>{paymentTypeHandler.plural()} Paused</PopoverTitle>
      <PopoverBorder />
      <PopoverMessage>
        This recurring {paymentType} is currently paused. Click Resume below to
        resume your next {paymentType} on <strong>{nextPaymentDate}</strong>.
      </PopoverMessage>
      <PopoverButtonsContainer>
        <FnrButton
          onClick={resuming ? null : handleClose}
          disabled={resuming}
          size="small"
        >
          Cancel
        </FnrButton>
        <FnrButton
          color="green"
          loading={resuming}
          onClick={handleResume}
          size="small"
        >
          Resume
        </FnrButton>
      </PopoverButtonsContainer>
    </PopoverContent>
  );
}
